import { Tooltip } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import {
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  gridFilterModelSelector,
  Toolbar,
  ToolbarButton,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-pro';
import { StyledQuickFilter } from '@components/DataGrid/StyledComponents';
import DensityMenuButton from '@components/DataGrid/ToolbarItems/DensityMenu';

/** Stable id so the toggle's filter can be found/removed without touching manual filters */
const NEGATIVE_FILTER_ID = 'negative-commissions';

function NegativeCommissionsToggle() {
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const isActive = filterModel.items.some((item) => item.id === NEGATIVE_FILTER_ID);

  const toggle = () => {
    const items = filterModel.items.filter((item) => item.id !== NEGATIVE_FILTER_ID);
    apiRef.current.setFilterModel({
      ...filterModel,
      items: isActive ? items : [...items, { id: NEGATIVE_FILTER_ID, field: 'amount', operator: '<', value: 0 }]
    });
  };

  return (
    <Tooltip title='Show only negative commissions'>
      <ToolbarButton
        aria-pressed={isActive}
        color={isActive ? 'primary' : 'default'}
        onClick={toggle}>
        <TrendingDownIcon
          fontSize='small'
          color={isActive ? 'primary' : undefined}
        />
      </ToolbarButton>
    </Tooltip>
  );
}

export function CommissionsToolbar() {
  return (
    <Toolbar style={{ justifyContent: 'flex-end' }}>
      <Tooltip title='Columns'>
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize='small' />
        </ColumnsPanelTrigger>
      </Tooltip>
      <Tooltip title='Filters'>
        <FilterPanelTrigger render={<ToolbarButton />}>
          <FilterListIcon fontSize='small' />
        </FilterPanelTrigger>
      </Tooltip>
      <NegativeCommissionsToggle />
      <DensityMenuButton />
      <StyledQuickFilter />
    </Toolbar>
  );
}
